
// import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Title from 'components/Title/Title';
import Scanner from 'components/Scanner/Scanner';
import styles from './Qr.module.scss';

const Qr = observer(() => {
  const navigate = useNavigate();

  function submit(number) {
    navigate(`/scooters/${number}`);
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Title>
          Start Ride
        </Title>
      </div>
      
      <Scanner onScan={submit} />

      <div className={styles.collage}>
        <div className={styles.collageBody} />
      </div>
    </div>
  );
});

export default Qr;
